import {
  TextInput,
  Button,
  Group,
  LoadingOverlay,
  Text,
  PasswordInput,
  Title,
  Stack,
  Anchor
} from '@mantine/core';
import { useForm } from '@mantine/form';
import instance from '../../axiosApi';
import { useState } from 'react';

function RegisterForm() {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isResendConfirmation, setIsResendConfirmation] = useState(false);
  const form = useForm({
    initialValues: {
      email: '',
      password: '',
      confirmPassword: ''
    },
    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) && !/\s/.test(value) ? null : 'Invalid email'),
      password: (value) => {
        if (value.length < 6) {
          return 'Password must be at least 6 characters';
        }
        if (!/[a-z]/.test(value) || !/[A-Z]/.test(value) || !/\d/.test(value)) {
          return 'Password must contain at least one lowercase letter, one uppercase letter, and one number';
        }
        return null;
      },
      confirmPassword: (value, values) =>
        value !== values.password ? 'Passwords did not match' : null
    }
  });

  const handleRegister = () => {
    setIsLoading(true);
    const emailLower = form.values.email.toLowerCase();
    instance
      .post('/api/auth/register', {
        email: emailLower,
        password: form.values.password
      })
      .then((response) => {
        console.log(response);
        setMessage('Registration successful');
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setMessage(error.response.data.message);
        setIsLoading(false);
      });
  };
  const handleResendConfirmation = () => {
    setIsLoading(true);
    const emailLower = form.values.email.toLowerCase();
    instance
      .post('/api/auth/resend-verification-email', {
        email: emailLower
      })
      .then((response) => {
        console.log(response);
        setMessage('Confirmation email resent');
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setMessage(error.response.data.message);
        setIsLoading(false);
      });
  };

  if (message == 'Registration successful')
    return (
      // Code to display a sucessful registration message and tell th euser they should verify their email

      <Stack>
        <Title color="green" order={5}>
          Registration successful
        </Title>
        <Text color="dimmed" size="sm">
          Confirmation email sent. Remember to check your spam folder.
        </Text>
      </Stack>
    );
  return (
    <form onSubmit={form.onSubmit(handleRegister)}>
      <div>
        <LoadingOverlay visible={isLoading} />
        <TextInput
          withAsterisk
          label="Email"
          placeholder="your@email.com"
          {...form.getInputProps('email')}
        />
        {!isResendConfirmation ? (
          <>
            <PasswordInput
              withAsterisk
              label="Password"
              placeholder="Password"
              {...form.getInputProps('password')}
            />
            <PasswordInput
              withAsterisk
              label="Confirm password"
              placeholder="Confirm password"
              {...form.getInputProps('confirmPassword')}
            />{' '}
          </>
        ) : (
          <></>
        )}

        <Group position="right" mt="md">
          {isResendConfirmation ? (
            <Button variant="gradient" fullWidth compact onClick={handleResendConfirmation}>
              Resend Confirmation
            </Button>
          ) : (
            <Button variant="gradient" fullWidth compact type="submit">
              Register
            </Button>
          )}
        </Group>
        <Text
          size="sm"
          color={message === 'Registration successful. Confirmation email sent.' ? 'green' : 'red'}>
          {message}
        </Text>
        {/* <Anchor href="/login">Already have an account? Login here.</Anchor>
        <Anchor href="/forgot-password">Forgot password?</Anchor> */}
        {!isResendConfirmation ? (
          <Anchor
            style={{
              marginTop: '10px',
              marginBottom: '10px',
              display: 'block',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 400
            }}
            onClick={() => setIsResendConfirmation(true)}>
            Resend Confirmation?
          </Anchor>
        ) : (
          <Anchor
            style={{
              marginTop: '10px',
              marginBottom: '10px',
              display: 'block',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 400
            }}
            onClick={() => setIsResendConfirmation(false)}>
            Sign-up
          </Anchor>
        )}
      </div>
    </form>
  );
}

export default RegisterForm;
